import { __generator, __values } from "tslib";
import { partial } from 'lodash-es';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import * as actionCreators from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import { getCurrentScreen, getSectionID, isImageLoaded } from '../selectors';
import * as api from '../services/api';
import { addHotspots } from '../updateProjectConfig';
export default function loadHotspots() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actionTypes.LOAD_FULL_PROJECT_DONE, function (_a) {
                    var project = _a.project, token = _a.token;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, put(actionCreators.loadHotspotsStarting())];
                            case 1:
                                _b.sent();
                                return [5 /*yield**/, __values(fetchHotspots(project.id, partial(api.getHotspots, project.id, token), partial(updateHotspots, project), actionCreators.loadHotspotsFailed))];
                            case 2:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function fetchHotspots(id, apiFn, done, failed) {
    var hotspots, sectionID, currentScreen, isLoaded, err_1, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 9, , 13]);
                return [4 /*yield*/, call(apiFn)];
            case 1:
                hotspots = _a.sent();
                return [4 /*yield*/, select(getSectionID)];
            case 2:
                sectionID = _a.sent();
                return [4 /*yield*/, put(done(hotspots, sectionID))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(actionCreators.loadHotspotsDone())];
            case 4:
                _a.sent();
                return [4 /*yield*/, select(getCurrentScreen)];
            case 5:
                currentScreen = _a.sent();
                return [4 /*yield*/, select(isImageLoaded, currentScreen.id)];
            case 6:
                isLoaded = _a.sent();
                if (!isLoaded) return [3 /*break*/, 8];
                return [4 /*yield*/, put(actionCreators.screenTimer(currentScreen.timer))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 13];
            case 9:
                err_1 = _a.sent();
                if (!(err_1 instanceof window.Response)) return [3 /*break*/, 11];
                response = err_1;
                if (!(response.status === 404)) return [3 /*break*/, 11];
                // eslint-disable-next-line no-console
                console.error("Hotspots with id '" + id + "' does not exist.");
                return [4 /*yield*/, put(actionCreators.notFound(id))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [4 /*yield*/, put(failed(id, err_1))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function updateHotspots(project, hotspots, sectionID) {
    var origProjectConfig = project.origProjectConfig;
    return actionCreators.setProject(addHotspots(origProjectConfig, hotspots), sectionID);
}
